import { ModalBody } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { financeAssets } from '../../../services/constant';
const ConfirmModal = ({confirm , setConfirm ,setRefund}) => {
    const onClose = () => { setConfirm(false)};
    return (
        <Modal
        show={confirm}
        onHide={onClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        style={{ maxWidth: '100%', borderRadius: '1.2rem', border: '1px solid #fff', overflow: 'hidden' }}
        > 
            <ModalBody>
                <div className='flex flex-col px-[6.5rem] py-[14.3rem] items-center'>
                    <img src={financeAssets.alert_info} alt='' className='w-[6rem] h-[6rem]'/>
                    <h4 className='font-24-600 text-black mt-[5rem]'>O seu pedido de reembolso foi enviado com sucesso!</h4>
                    <p className='font-16-500 font-color mt-[3.5rem] text-center' >A Habit irá analisar o seu pedido e proceder ao reembolso o mais <br /> brevemente possível.  </p>
                    <button className='w-[10.2rem] h-[4rem] rounded-[10rem] bg-[#FBBD18] text-white font-15-900 mt-[5.6rem]' onClick={() => {setConfirm(false); setRefund(true);}}>OK </button>
                </div>

            </ModalBody>
        </Modal>
    );
}
export default ConfirmModal;